import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EditProductComponent } from '@teem/product-module/modals/edit-product/edit-product.component';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ProductService } from '@teem/services/product.service';
import { LoaderService } from '@teem/services/loader.service';
import { Product } from '@teem/models/product';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/app/core/constants/messages';
@Component({
  selector: 'product-table',
  templateUrl: './product-table.component.html',
  styleUrls: ['./product-table.component.scss']
})
export class ProductTableComponent implements OnInit {
  @Output() onEditProduct: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onStatusChange: EventEmitter<any> = new EventEmitter();
  @Input() paginator;
  @Input() isProductSelected;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Input('myProducts') myProducts:Product[];
  @Output() hasChanges = new EventEmitter<boolean>();
  locale: string = 'en';
  product: any = {};
  basicInfo:any;
  selectKey: string = 'uuid';
  selected: Array<any> = [];
  selectedRows: Array<any> = [];
  showMenu: boolean = false;

  constructor(
    private productService: ProductService,
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService ,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if(data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
  }

  ngOnChanges() {
    this.reset();
  }

  reset() {
    this.selected = [];
    this.selectedRows = [];
    this.showMenu = false;
  }

  toggleSelect(id: any, row: any) {
    let index = this.selected.indexOf(id);
    if (index == -1) {
      this.selected.push(id);
      this.selectedRows[row[this.selectKey]] = row;
      // this.onSelect.emit(Object.values(this.selectedRows))
      this.onSelect.emit(Object.values(this.selected))
    } else {
      this.selected.splice(index, 1);
      delete this.selectedRows[row[this.selectKey]];
      // this.onSelect.emit(Object.values(this.selectedRows));
      this.onSelect.emit(Object.values(this.selected));
      if (this.selected.length == 0) {
        this.showMenu = false;
      }
    }
  }

  toggleSelectAll() {
    if (this.selected.length < this.myProducts.length) {
      let selected = [];
      for (let item of this.myProducts)
        selected.push(item[this.selectKey])

      this.selected = selected;

      this.selectedRows = this.myProducts;
    } else {
      this.selected = [];
    }
  }

  editProduct(product: any) {
    this.cancelAllEdits();
    this.loaderService.startLoading();
    this.productService.get(product.uuid).subscribe(product => {
      this.product = product;
      this.openEditProductModal();
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openEditProductModal() {
    let modalRef = this.modalService.open(EditProductComponent);
    modalRef.componentInstance.productInfo = this.product;

    const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;
    parentElement.id = "add-product-service";
    parentElement.classList.add( "new-product-service");

    modalRef.result.then(
      onfulfilled => {
        this.onEditProduct.emit();
      },
      onrejected => {

      }
    );
  }

  deleteProduct(product) {
    this.cancelAllEdits()
    this.onDelete.emit(product);
  }

  showHideProduct(product: any, key: string, type: 'status-update' | 'stock-status') {
		this.productService.action({ 'do': type, 'ids': [product.uuid] }).subscribe(response => {
      console.log(response);
    }, err => {
      console.error(err);
    });
    
		product[key] = !product[key];
	}

  // showHideProduct(product: any) {
  //   this.onStatusChange.emit(product);
  //   // this.loaderService.startLoading();
  //   // this.productService.action({'do': 'status-update', 'ids': [product.uuid]}).subscribe(product => {
  //   //   this.product = product;
  //   //   this.loaderService.stopLoading();
  //   // }, err => {
  //   //   this.loaderService.stopLoading();
  //   // })
  // }

  emitEditStatus() {
    this.hasChanges.emit(this.hasEdits());
  }

  editingCell: { [key: string]: boolean } = {};
  editedValues: { [uuid: string]: Partial<Product> } = {};

  startEdit(uuid: string, field: keyof Product): void {
    this.editingCell[`${uuid}_${field}`] = true;
  }

  stopEdit(uuid: string, field: keyof Product, newValue: any): void {
    const key = `${uuid}_${field}`;
    this.editingCell[key] = true;

    const originalProduct = this.myProducts.find(p => p.uuid === uuid);
    if (!originalProduct) return;

    if (originalProduct[field] !== newValue) {
      if (!this.editedValues[uuid]) {
        this.editedValues[uuid] = { uuid }; // Include UUID for API mapping
      }
      if(field == 'price'){
        (this.editedValues[uuid] as any)[field] = newValue.toFixed(2);
      }else{
        (this.editedValues[uuid] as any)[field] = newValue;
      }
    }
    this.emitEditStatus();
  }

  cancelAllEdits(): void {
    // Exit edit mode for all cells
    this.editingCell = {};

    // Clear edited values
    this.editedValues = {};

    // Notify parent (if needed)
    this.emitEditStatus();
  }

  saveAll(): void {

    const updates: Partial<Product>[] = Object.values(this.editedValues);

    if (updates.length === 0) return;
    this.loaderService.startLoading();
    this.productService.updateProducts({ products: updates }).subscribe({
      next: () => {
        this.editingCell = {};
        // Apply changes locally
        updates.forEach(update => {
          const localProduct = this.myProducts.find(p => p.uuid === update.uuid);
          
          if (localProduct) {
            Object.assign(localProduct, update);
          }
        });
        this.loaderService.stopLoading();
        this.editedValues = {};
        Swal.fire(i18n.alert.success,i18n.success.changes_saved_successfully,'success');
        this.emitEditStatus();
      },
      error: (err) => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error,i18n.error.something_went_wrong,'error');
      }
    });
    this.emitEditStatus();
  }

  hasEdits(): boolean {
    return Object.keys(this.editedValues).length > 0;
  }
}
